import api from './api'
import categories from './categories/api'
import moment from 'moment'
import siteVersions from '../site-versions/api'

export default {
  namespaced: true,
  state: {
    routeKey: 'newsId',
    routes: {
      index: 'news.index',
      create: 'news.create',
      edit: 'news.edit'
    },
    table: [
      { code: 'site_versions', type: 'function', get: data => data.map(item => item.name).join(', ') },
      { code: 'date', type: 'date', sort: true },
      { code: 'publish', type: 'boolean' },
      { code: 'code', type: 'string', sort: true },
      { code: 'name', type: 'string', sort: true },
      { code: 'category', type: 'function', get: data => data?.name },
      { code: 'preview_image', type: 'image', width: 100 },
      { code: 'created_at', type: 'datetime', sort: true },
      { code: 'updated_at', type: 'datetime', sort: true }
    ],
    form: [
      { code: 'site_versions', type: 'multiselect', options: [], size: 6, validation: { required: true } },
      { code: 'publish', type: 'boolean' },
      { code: 'date', type: 'date', validation: { required: true } },
      { code: 'code', type: 'text', validation: { required: true } },
      { code: 'name', type: 'text', validation: { required: true } },
      { code: 'category_id', type: 'select', options: [], validation: { integer: true } },
      { code: 'preview_image', type: 'image' },
      { code: 'detail_image', type: 'image' },
      { code: 'external_link', type: 'text' },
      { code: 'preview_text', type: 'textarea' },
      { code: 'detail_text', type: 'textarea' }
    ],
    item: {},
    items: [],
    meta: {},
    page: 1,
    sort: '-date'
  },
  mutations: {
    SET_ITEMS (state, data) {
      state.items = data.data || null
      state.meta = data.meta || null
    },
    SET_ITEM (state, data) {
      state.item = {
        id: data.id || null,
        locales: data.locales || [],
        site_versions: data.site_versions?.map(item => item.id) || [],
        publish: data.publish === true ? 1 : null,
        date: data.date ? moment(data.date).format('DD.MM.YYYY') : null,
        code: data.code || null,
        name: data.name || null,
        category_id: data.category?.id || null,
        preview_image_old: data.preview_image || null,
        preview_image: null,
        preview_image_delete: null,
        detail_image_old: data.detail_image || null,
        detail_image: null,
        detail_image_delete: null,
        external_link: data.external_link || null,
        preview_text: data.preview_text || null,
        detail_text: data.detail_text || null
      }
    },
    SET_SELECT_OPTIONS (state, { code, options }) {
      state.form.find(item => item.code === code).options = options
    },
    SET_SORT (state, field) {
      state.sort = state.sort === field ? `-${field}` : field
    },
    SET_PAGE (state, page) {
      state.page = page
    }
  },
  actions: {
    async fetchItems ({ commit, state }) {
      const { data } = await api.index({
        'sort': state.sort,
        'page[number]': state.page
      })

      commit('SET_ITEMS', data)
    },
    clearItems ({ commit }) {
      commit('SET_ITEMS', {})
    },
    async fetchItem ({ commit }, { route }) {
      const { data: { data } } = await api.show(route.params.newsId)

      commit('SET_ITEM', data)
    },
    clearItem ({ commit }) {
      commit('SET_ITEM', {})
    },
    async fetchCategories ({ commit }) {
      const { data: { data } } = await categories.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'category_id', options })
    },
    async fetchSiteVersions ({ commit }) {
      const { data: { data } } = await siteVersions.index({
        'sort': 'weight',
        'page[all]': true
      })

      const options = data.map(item => ({
        value: item.id,
        text: item.name
      }))

      commit('SET_SELECT_OPTIONS', { code: 'site_versions', options })
    },
    async createItem ({ commit }, { form }) {
      const { data: { data } } = await api.store(form)

      commit('SET_ITEM', data)
    },
    async updateItem ({ commit }, { route, form }) {
      const { data: { data } } = await api.update(route.params.newsId, form)

      commit('SET_ITEM', data)
    },
    async deleteItem ({ commit }, { id }) {
      await api.destroy(id)
    }
  }
}
